import { useAccountInviteCancelMutation } from '~/generated/graphql';

export function useInviteCancel() {
  const [inviteCancel, { loading }] = useAccountInviteCancelMutation();

  return {
    inviteCancel,
    loading,
  };
}
